import { render, staticRenderFns } from "./RoomProvidersSummary.vue?vue&type=template&id=2e1d49a8&scoped=true&"
import script from "./RoomProvidersSummary.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RoomProvidersSummary.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./RoomProvidersSummary.vue?vue&type=style&index=0&id=2e1d49a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1d49a8",
  null
  
)

export default component.exports